import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=64a1208c&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=64a1208c&prod&lang=stylus&scoped=true"
import style1 from "./LoginForm.vue?vue&type=style&index=1&id=64a1208c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1208c",
  null
  
)

export default component.exports